import React, { useContext, createContext, useState } from 'react'

type DrawerWidthContextType = [number, React.Dispatch<React.SetStateAction<number>>]

const DrawerWidthContext = createContext<DrawerWidthContextType>([0, () => {}])


export const useDrawerWidthContext = () => useContext(DrawerWidthContext)

export const DrawerWidthProvider = ({ children }: { children: React.ReactNode }) => {
  const [drawerWidth, setDrawerWidth] = useState(0)
  return <DrawerWidthContext.Provider value={[drawerWidth, setDrawerWidth]}>{children}</DrawerWidthContext.Provider>
}
